'use strict';
const angular = require('angular');

/*@ngInject*/
export function GalleryService($resource) {
  return $resource('/api/galleries/:id', {
    id: '@_id'
  },{
    getByType: {
      method: 'GET',
      url: "/api/galleries/type/:type",
      isArray: true
    },
    getPublicByType: {
      method: 'GET',
      url: "/api/galleries/type/:type/public",
      isArray: true
    },
    getNewest: {
      method: 'GET',
      url: "/api/galleries/newest/:count",
      isArray: true
    },
    getNewestByCategories: {
      method: 'GET',
      url: "/api/galleries/newest/:count/:categories",
      isArray: true
    },
    getPublic: {
      method: 'GET',
      url: "/api/galleries/public/:id"
    },
    patch: {
      method: 'PATCH'
    }
  });
}


export default angular.module('conduuApp.GalleryService', [])
  .factory('GalleryService', GalleryService)
  .name;



// WEBPACK FOOTER //
// ./client/services/gallery/gallery.service.js